import React from 'react';

import styles from './mapDot.module.css';

type MapDotProps = {
  top: string;
  left: string;
  label: string;
  color: string;
  onClick: () => void;
  selected?: boolean;
  children?: React.ReactNode;
};

export default function MapDot({ top, left, color, label, onClick, selected = false, children }: MapDotProps) {
  return (
    <div className={styles.mapDotContainer} style={{ top, left, position: 'absolute' }}>
      <button
        className={`${styles.mapDotButton} ${selected ? styles.selected : ''}`}
        style={{ background: color }}
        onClick={onClick}
      >
        {children}
      </button>
      <span style={{ cursor: 'pointer', fontWeight: selected ? 'bold' : undefined }} onClick={onClick}>
        {label}
      </span>
    </div>
  );
}
